import { useSelector } from 'react-redux'

import { toast } from '@webapp/components/Notification'
import {
  type FeatureExpansionRequestType,
  type MarketoFormContext,
  type MarketoServiceError,
} from '@webapp/core/services/Marketo'
import { makeSelectDomain, makeSelectUser } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateRequestFeatureDemo } from '../../models'

interface IUseRequestFeatureDemoButtonPresenterProps {
  context: FeatureExpansionRequestType
  onSuccess?: () => void
  onError?: (error: MarketoServiceError) => void
}

export const useRequestFeatureDemoButtonPresenter = ({
  context,
  onSuccess,
  onError,
}: IUseRequestFeatureDemoButtonPresenterProps) => {
  const intl = useProcurifyIntl()
  const user = useSelector(makeSelectUser())
  const domain = useSelector(makeSelectDomain())

  const { mutateAsync, isLoading } = useMutateRequestFeatureDemo()

  const requestDemo = async () => {
    const marketoContext: MarketoFormContext = {
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      domain,
      context,
    }

    try {
      await mutateAsync(marketoContext)

      onSuccess?.()

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch (e) {
      onError?.(e as MarketoServiceError)

      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children: intl.formatMessage(messages.errorMessage),
      })
    }
  }

  return {
    states: {
      isSubmitting: isLoading,
    },
    commands: {
      requestDemo,
    },
  }
}
